import React from "react"

/**
 * RequiredInfoBanner shows for admin users when account needs required info.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/_required_info_needed.html.erb
 *
 * @param {string} requiredInfoDetails - The details of the required info
 */
export function RequiredInfoBanner({ requiredInfoDetails }) {
  return (
    <div className="alert alert--banner alert--admin">
      <span className="label">admin</span>
      This account still needs to {requiredInfoDetails} before sending can be
      enabled.
    </div>
  )
}
